export const DATA = {
  BING: {
    key: 'AsVccaM44P5n-GYKXaV0oVGdTI665Qx_sMgYBSYRxryH2pLe92iVxUgEtwIt8des',
    imagerySet: ['AerialWithLabels']
  },
  WMS: {
    // imageA: {
    //   extent: [0, -3648.3845212884353, 5472.077182543888, 0],
    //   TRANSFORM_MATRIX: [
    //     [
    //       // x1, y1  - Q11
    //       [0, 0],
    //       [34.91362133519737, 32.31144634590263]
    //     ],
    //     [
    //       // x1, y2 - Q12
    //       [0, 3648.3845212884353],
    //       [34.91280043442864, 32.311824153395875]
    //     ],
    //     [
    //       // x2, y1 - Q21
    //       [5472.077182543888, 0],
    //       [34.91429195343733, 32.31248660001708]
    //     ],
    //     [
    //       // x2, y2 - Q22
    //       [5472.077182543888, 3648.3845212884353],
    //       [34.91347491739288, 32.31287033131449]
    //     ]
    //   ],
    //   url: 'http://geoserver.ansyn.webiks.com/geoserver/public/wms',
    //   LAYERS: 'public:f62b66d9_c1e7_4975_8188_289b0aff5d70'
    // },
    imageB: {
      extent: [0, -3000.2799668788402, 4000.040284737165, 0],
      TRANSFORM_MATRIX: [
        [
          [
            7.812578681127235,
            -2097.677375882673
          ],
          [
            3886159.8021447076,
            3803932.293233304
          ]
        ],
        [
          [
            11.718868021690895,
            -621.1000051496184
          ],
          [
            3886158.77722202,
            3803805.023872538
          ]
        ],
        [
          [
            2742.2151170756733,
            -2101.583665223237
          ],
          [
            3886082.069862602,
            3803954.9301670683
          ]
        ],
        [
          [
            535.1616396572183,
            -1195.3245382124733
          ],
          [
            3886137.7167376042,
            3803879.4030681183
          ]
        ],
        [
          [
            722.6635280042728,
            -1187.5119595313458
          ],
          [
            3886130.5265288646,
            3803882.283991592
          ]
        ],
        [
          [
            695.3195026203274,
            -1105.4798833795094
          ],
          [
            3886130.379368008,
            3803871.766620189
          ]
        ],
        [
          [
            660.1628985552547,
            -968.7597564597821
          ],
          [
            3886128.8661186127,
            3803856.9114033957
          ]
        ],
        [
          [
            796.883025474982,
            -984.3849138220367
          ],
          [
            3886122.982896238,
            3803861.723651715
          ]
        ],
        [
          [
            187.50188834705455,
            -1039.0729645899276
          ],
          [
            3886151.6179915178,
            3803854.8981704493
          ]
        ],
        [
          [
            1449.2333453491096,
            -835.9459188806185
          ],
          [
            3886093.8595165215,
            3803871.320189422
          ]
        ],
        [
          [
            1820.3308327026552,
            -843.7584975617458
          ],
          [
            3886075.5998938107,
            3803879.6871933276
          ]
        ],
        [
          [
            2195.3346093967643,
            -980.478624481473
          ],
          [
            3886057.236640368,
            3803898.253538721
          ]
        ],
        [
          [
            1031.2603859088003,
            -1308.6069290888186
          ],
          [
            3886117.845100404,
            3803898.320964978
          ]
        ],
        [
          [
            1285.1691930454367,
            -1339.8572438133278
          ],
          [
            3886109.4954625415,
            3803906.7872216487
          ]
        ]
      ],
      TRANSFORM_MATRIX2: [
        [
          [0, 0],
          [34.91000966631772, 32.30914520655708]
        ],
        [
          [0, 3000.2799668788402],
          [34.90979826294317, 32.30643997042385]
        ],
        [
          [4000.040284737165, 0],
          [34.909234372814, 32.309551578999454]
        ],
        [
          [4000.040284737165, 3000.2799668788402],
          [34.906384529582624, 32.308148863431796]
        ]
      ],
      TRANSFORM_MATRIX_BEST: [
        [
          [
            [0, 0],
            [34.90989004595932, 32.30761064507408]
          ],
          [
            [3992.227706647056, 0],
            [34.90860429842663, 32.30761064507408]
          ]
        ],
        [
          [[0, 2971.7096162737257], [34.90989004595932, 32.3093548651307]],
          [[3992.227706647056, 2971.7096162737257], [34.90860429842663, 32.3093548651307]]
        ]
      ],
      TRANSFORM_MATRIX3: [
        [
          [
            [
              0,
              0
            ],
            [
              34.90989004595932,
              32.30761064507408
            ]
          ],
          [
            [
              1330.742568882352,
              0
            ],
            [
              34.90946146344842,
              32.30761064507408
            ]
          ],
          [
            [
              2661.485137764704,
              0
            ],
            [
              34.90903288093753,
              32.30761064507408
            ]
          ],
          [
            [
              3992.227706647056,
              0
            ],
            [
              34.90860429842663,
              32.30761064507408
            ]
          ]
        ],
        [
          [
            [
              0,
              990.5698720912419
            ],
            [
              34.90989004595932,
              32.30819205175962
            ]
          ],
          [
            [
              1330.742568882352,
              990.5698720912419
            ],
            [
              34.90946146344842,
              32.30819205175962
            ]
          ],
          [
            [
              2661.485137764704,
              990.5698720912419
            ],
            [
              34.90903288093753,
              32.30819205175962
            ]
          ],
          [
            [
              3992.227706647056,
              990.5698720912419
            ],
            [
              34.90860429842663,
              32.30819205175962
            ]
          ]
        ],
        [
          [
            [
              0,
              1981.1397441824638
            ],
            [
              34.90989004595932,
              32.30877345844516
            ]
          ],
          [
            [
              1330.742568882352,
              1981.1397441824638
            ],
            [
              34.90946146344842,
              32.30877345844516
            ]
          ],
          [
            [
              2661.485137764704,
              1981.1397441824638
            ],
            [
              34.90903288093753,
              32.30877345844516
            ]
          ],
          [
            [
              3992.227706647056,
              1981.1397441824638
            ],
            [
              34.90860429842663,
              32.30877345844516
            ]
          ]
        ],
        [
          [
            [
              0,
              2971.7096162737257
            ],
            [
              34.90989004595932,
              32.3093548651307
            ]
          ],
          [
            [
              1330.742568882352,
              2971.7096162737257
            ],
            [
              34.90946146344842,
              32.3093548651307
            ]
          ],
          [
            [
              2661.485137764704,
              2971.7096162737257
            ],
            [
              34.90903288093753,
              32.3093548651307
            ]
          ],
          [
            [
              3992.227706647056,
              2971.7096162737257
            ],
            [
              34.90860429842663,
              32.3093548651307
            ]
          ]
        ]
      ],

      url: 'http://geoserver.ansyn.webiks.com/geoserver/public/wms',
      LAYERS: 'public:def4f9ff_6aa0_4a33_a458_08bda0f54e1b'
    }
  }
};
